<template>
  <div class="contact_maxbox">
    <!-- PC/手机 通用 -->
    <home-nav></home-nav>
    <!-- 聯繫我們 -->
    <div>
      <!-- 分割线 -->
      <div class="cut_off"></div>

      <!--  聯繫我們-內容： -->
      <div class="contact_box">
        <div class="contact">

          <!-- 左边 -->
          <div class="brr_right">
            <p class="title_box">
              <span>聯絡我們</span>
              <span class="gray_box wh_box"></span>
            </p>
            <!-- 姓名： -->
            <div class="content_box">
              <span>姓名：</span>
              <el-input v-model="nameVal" placeholder="請輸入姓名"></el-input>
              <span class="remind_box" v-show="nameTF">請輸入中文</span>
            </div>
            <!-- 手機號碼： -->
            <div class="content_box">
              <span>手機號碼：</span>
              <el-input v-model="telVal" placeholder="請輸入手機號碼"></el-input>
              <span class="remind_box"  v-show="telTF">請輸入正確手機號碼</span>
            </div>
            <!-- 電子信箱： -->
            <div class="content_box">
              <span>電子信箱：</span>
              <el-input v-model="emailVal" placeholder="請輸入電子信箱"></el-input>
              <span class="remind_box" v-show="emailTF">請輸入正確mail</span>
            </div>
            <!-- 聯絡內容： -->
            <div class="content_box tex_maxbox">
              <span class=" tex_box">聯絡內容：</span>
              <el-input class=" textarea_box" :rows="6" type="textarea" v-model="textVal" resize="none"></el-input>
            </div>
            <div class="remind_tex">
              <span v-show="textTF">您尚未填寫內容</span>
            </div>

            <!-- 按鈕： -->
            <div class="btn_box">
              <el-button type="primary" @click="btnFun()">送出留言</el-button>
            </div>

          </div>

          <!-- 右边： -->
          <div>
            <p class="title_box">
              <span>台易購金融科技有限公司</span>
              <span class="gray_box tyg_box"></span>
            </p>
            <div class="content_box">
              TEL: 02-2212-5312
            </div>
            <div class="content_box">
              FAX: 02-2212-3192
            </div>
            <div class="content_box">
              ADD: 新北市231新店區安興路117號12樓之7
            </div>
            
            <!-- 地圖 -->
            <div class="map_box">
              地圖插件
            </div>

            <div class="content_box">
              @: tyg8899@outlook.com
            </div>

          </div>

          <!-- END-左/右 -->
        </div>
      </div>

    </div>
    <!-- footer -->
    <home-footer></home-footer>
    <phone-footer></phone-footer>
    <!-- footer-END -->
  </div>

</template>

<script>
import HomeNav from '../common/Nav.vue';
import HomeFooter from '../common/Footer.vue';
import PhoneFooter from '../common/PhoneFooter.vue';

import axios from 'axios';

export default {
  name: 'Contact',
  props: {
  },
  data() {
    return {
      nameVal: '',
      nameTF: false,
      telVal: '',
      telTF: false,
      emailVal: '',
      emailTF: false,
      textVal: '',
      textTF: false,
    }
  },
  methods: {
    // 送出留言：
    btnFun(){
      // 姓名：
      if(this.nameVal == ''){
        this.nameTF = true;
      } else {
        this.nameTF = false;
      }
      // 手機號碼：
      if(this.telVal == ''){
        this.telTF = true;
      } else {
        this.telTF = false;
      }
      // 電子信箱：
      if(this.emailVal == ''){
        this.emailTF = true;
      } else {
        this.emailTF = false;
      }
      // 聯絡內容：
      if(this.textVal == ''){
        this.textTF = true;
      } else {
        this.textTF = false;
      }

    },



  },
  components: {
    HomeNav,
    HomeFooter,
    PhoneFooter
  },
  computed: {

  },
  mounted(){

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 分割线 */
	.cut_off {
		height: 4px;
		background: #e73262;
	}
  .title_box {
    position: relative;
    font-size: 29px;
    font-weight: bold;
    color: #777777;
    margin-bottom: 40px;
  }
  .title_box .gray_box {
    z-index: -1;
    box-sizing: border-box;
    display: block;
    background: #f2f2f2;
    position: absolute;
    top: 10px;
    left: -4px;
  }
  .title_box .wh_box {
    width: 140px;
    height: 30px;
  }
  .title_box .tyg_box {
    width: 340px;
    height: 30px;
  }
  .btn_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
  }
  .btn_box .el-button {
    width: 150px;
    border-radius: 15px;
  }
/* 內容： */
  .contact_box {
    padding: 40px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .contact {
    box-sizing: border-box;
    border: 2px solid #cccccc;
    width: 1200px;
    min-height: 500px;
    display: flex;
    color: #777777;
  }
  .contact >div {
    box-sizing: border-box;
    padding: 40px;
    width: 50%;
    /* height: 100%; */
  }
  .brr_right {
    border-right: 2px solid #cccccc;
  }
  .content_box {
      display: flex;
      align-items: center;
      font-size: 19px;
  }
  .tex_maxbox {
      display: flex;
      align-items: flex-start;
  }
  .content_box >span {
    display: block;
    width: 100px;
    /* text-align: right; */
  }
  .content_box .el-input {
    width: 290px;
  }
  .content_box+.content_box {
    margin-top: 20px;
  }
  .content_box .tex_box {
    width: 124px;
  }
  .content_box .remind_box {
    margin-left: 6px;
    font-size: 13px;
    color: #e73262;
    width: 120px;
    /* display: none; */
  }
  .remind_tex {
    color: #e73262;
    margin-top: 10px;
    margin-left: 100px;
    height: 20px;
  }
  .remind_tex >span {
    /* display: none; */
  }

  /* 地圖 */
  .map_box {
    box-sizing: border-box;
    margin: 10px 0;
    height: 250px;
    background: #cccccc;
    /*  */
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 19px;
  }


</style>
